import { DataTable } from "../../../data-table.interface";
import { consolidatedPickingDetail } from "../picking-consolidated-detail.config";

export const detailOfDispatchesToCreateLots:DataTable = {
searchText: '',
addText: '',
checkbox: false,
expandable: false,
paginator: true,
filter: false,
filterDefault: '',
disabled: false,
partialField: '',
show: 'No se encontraron resultados para mostrar.',
columns:consolidatedPickingDetail.columns
}
